<div class="wrapper wrapper-content mtv-directory-page animated fadeInRight row hide-list-nav-tabs settings-amenities">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="settingsKeyLogService.showDetailedView"
         [ngStyle]="{width: settingsKeyLogService.showDetailedView ? 'calc(100% - 520px)' : '100%'}">
        <div class="ibox-content no-scroll-mode">
            <div class="row">
                <div class="col-sm-12">
                    <filter [tabHeading]="'Corporation'"></filter>
                </div>
            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'allSettingsKeyLog'" [ngClass]="{'sk-loading': settingsKeyLogService.spinnerShow}">
                    <corporations-list></corporations-list>
                    <spinner [spinnerShow]="settingsKeyLogService.spinnerShow"></spinner>
                </tab-item>
                <pagination *ngIf="settingsKeyLogService.data.corporations.data.length > 0 && urlService.queryParams['page']"
                            [total]="settingsKeyLogService.data.corporations.total">
                </pagination>
            </tabs-wrapper>
        </div>
    </div>

    <div class="animated animated-directory slideInRight detailed-view dv-sidebar">
        <settings-key-log-detailed-view></settings-key-log-detailed-view>
    </div>
</div>
<notifications-modal *ngIf="settingsKeyLogService.showNotificationsModal"></notifications-modal>



// WEBPACK FOOTER //
// /app/src/app/views/settings-key-log/settings-key-log.component.html